import React, {} from "react";
import {Layout} from "antd";
const {Content} = Layout;
 

function Data() {
  return (
    <Layout>
      <Layout>
        
        <Content className="bg-white">
          <div>Data of Sync will be here!</div>
        </Content>
      </Layout>
    </Layout>
  );
}

export default Data;
